import axios from '@/axiosInterceptor';

const state = () => ({
  currentUser: null,
  loading: false,
  senderEmail: '',
  search_result: {},
  show_fraud_form: false,
  error: null,
  last_searched_type: null,
  last_searched_value: null,
  search_mode_for_current_result: null,
});

const getters = {};

const actions = {
  async searchContact({ commit }, { type, value }) {
    commit('setLoading', true);
    // const body = { "${type}": value };
    let body;
    if (type == 'email') {
      body = { email: value?.trim() };
      commit('setSearchModeForCurrentResult', 'email');
    } else if (type == 'phone_e164') {
      body = { phone_e164: value };
      commit('setSearchModeForCurrentResult', 'phone');
    }
    if (type) {
      try {
        // const res = await axios.post('https://staging.highway.com/monitor/api/v1/carriers/email_search', body);
        // const res = await axios.post('https://staging.highway.com/core/connect/external_api/v1/carriers/email_search', body);
        // const res = await axios.post(process.env.ENV_URL+'/core/connect/external_api/v1/carriers/email_search_associated_carriers', body);
        // const res = await axios.post(process.env.ENV_URL+'/connect/external_api/v1/carriers/email_search_associated_carriers', body);
        let typeUrl = type == 'phone_e164' ? 'phone' : type;
        const res = await axios.post(
          process.env.API_MONITOR +
            '/api/v1/carriers/' +
            typeUrl +
            '_search_associated_carriers',
          body
        );
        if (res?.data) {
          await commit('setSearchResult', res?.data);
          commit('setLoading', false);
        }
        console.log('searchContact result for ' + type + ' ' + value + ':');
        console.dir(res);
        commit('setLastSearchedValue', { type: type, value: value?.trim() });
        return res;
      } catch (e) {
        console.log(
          'error in try/catch - searchContact result for ' +
            type +
            ' ' +
            value +
            ':'
        );
        console.dir(e);
        commit('setLoading', false);
        commit('setLastSearchedValue', value?.trim());
        if (axios.isAxiosError(e) && [403, 422].includes(e?.response?.status)) {
          commit('setError', e?.response);
          return e?.response;
        } else {
          commit('setError', e?.response?.statusText);
          throw e;
        }
      }
    } else {
      commit('setError', 'Please select a type of email or phone number.');
    }
  },

  async createAlert(_, payload) {
    console.log('alert payload:');
    console.dir(payload);
    const body = {
      identity_alert: {
        is_type: 'identity_theft',
        email: payload.email,
        phone_e164: payload.phone_e164,
        phone: payload.phone,
        unsanitized_message: payload.message,
        file_date: payload.file_date,
      },
    };
    try {
      let res = await axios.post(
        process.env.ENV_URL +
          process.env.API_IDENTITY +
          '/api/v1/identity_alerts',
        body
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setCurrentUser(state, user) {
    state.currentUser = user;
  },
  setSenderEmail(state, email) {
    state.senderEmail = email;
  },
  setRecipientEmail(state, email) {
    state.recipientEmail = email;
  },
  setEmailAccount(state, email) {
    state.emailAccount = email;
  },
  setSearchResult(state, data) {
    state.search_result = data;
  },
  setLoading(state, bool) {
    state.loading = bool;
  },
  setShowFraudForm(state, bool) {
    state.show_fraud_form = bool;
  },
  setOutlookSettings(state, data) {
    state.outlook_settings = data;
  },
  setError(state, data) {
    state.error = data;
  },
  setLastSearchedValue(state, { type, value }) {
    state.last_searched_value = value;
    state.last_searched_type = type;
  },
  setSearchModeForCurrentResult(state, value) {
    state.search_mode_for_current_result = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
